<template>
  <a :href="this.project.html_url">
    <div class="project-box">
      <h2>{{this.project.name}}</h2>
      <p class="project-desciption" v-if="this.project.description">{{this.project.description}}</p>
      <div class="logo">
        <div v-for="language in languages" :key="language">
          <project-img :language="language"/>
        </div>
      </div>
      <p class="project-data">Last Updated in {{getProjects()}}</p>
    </div>
  </a>
</template>

<script>
import { get } from "axios";
import ProjectImg from "./ProjectImg";

export default {
  name: "ProjectInfo",
  props: ["project"],
  components : {
    ProjectImg
  },
  data() {
    return {
      languages: []
    };
  },
  methods: {
    getProjects: function () {
      return this.project.updated_at.slice(0,10).split("-").reverse().join("-");

    },
    getProjectLanguage: function () {
      get("https://api.github.com/repos/BorjaZarco/"+this.project.name+"/languages")
        .then(res => {
          this.languages = Object.keys(res.data);
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  created () {
    this.getProjectLanguage();
  }
};
</script>

<style scoped>
a {
  color: black;
  text-decoration: none;
}

.project-box {
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  border-bottom: 1px solid gray;
  margin: 20px;
  padding: 20px;
  width: 50vw;
  transition-duration: 500ms;
  text-decoration: none;
}

.project-desciption {
  margin-top: 0;
}

.project-box:hover {
  transform: scale(1.1);
  transition-duration: 500ms;
}

.project-data {
  margin: 0;
  font-size: 0.75rem;
  text-decoration: none;
  color: black;
}

.project-box a {
  color: black;
  text-decoration: none;
  font-size: 1.5rem;
}

.project-box a:hover {
  cursor: pointer;
}

.logo {
  display: flex;
  float: left;
}
</style>



// WEBPACK FOOTER //
// src/components/children/ProjectInfo.vue